import React from 'react';

import { useDispatch } from 'react-redux';
import onPaginate from '@job-facets/components/pagination/Service';
import useArgsAddedQuery from '@job-facets/redux/reusableComponents';
import NumberedPaginationSection from '@react/shared-component/PaginationLists/View';

function PaginationSection() {
	const { data } = useArgsAddedQuery();
	const dispatch = useDispatch();

	return (
		<div className='pagination'>
			<NumberedPaginationSection
				totalPages={data?.totalPages ?? 1}
				injectCurrentPageNumber={data?.currentPage ?? 1}
				ItemClassNames='pagination__item px-md-16'
				onPageChange={(page) => onPaginate(page, dispatch)}
				paginationUrlParam='page_number'
			/>
		</div>
	);
}

export default PaginationSection;
